interface TourStep {
  key: string
  ref?: React.RefObject<HTMLDivElement>
  title: string
  description: string
  disableHighlight?: boolean
  textBoxXPlacement?: string
  textBoxYPlacement?: string
}

interface GuidedtourStepsProps {
  headerRef: React.RefObject<HTMLDivElement>
  syncButtonRef: React.RefObject<HTMLDivElement>
  emailSettingsButtonRef: React.RefObject<HTMLDivElement>
  coursesRef: React.RefObject<HTMLDivElement>
  emailEdit: boolean
}

const GuidedTourSteps = ({
  headerRef,
  syncButtonRef,
  emailSettingsButtonRef,
  coursesRef,
  emailEdit
}: GuidedtourStepsProps): TourStep[] => [
  {
    key: 'welcome',
    title: 'Welcome to your survey project!',
    description: 'This guided tour will walk you through the main features of the project page.',
    disableHighlight: true
  },
  {
    key: 'project-info',
    title: 'Project Information',
    description: 'Here you can view details about your survey project, such as its title, term, template, and important dates.',
    ref: headerRef
  },
  {
    key: 'sync-dates',
    title: 'Sync Course Section Dates',
    description: 'Click this button to synchronize the start, end, and release dates of surveys for all course sections.',
    ref: syncButtonRef
  },
  ...(emailEdit
    ? [
        {
          key: 'email-settings',
          title: 'Email Settings',
          description: 'Configure custom emails for your survey project here.',
          ref: emailSettingsButtonRef,
          textBoxXPlacement: 'end'
        },
        {
          key: 'email-scheduling',
          title: 'Email Scheduling',
          description: 'Schedule reminders, notifications, and release emails for students, instructors, and admins.',
          ref: emailSettingsButtonRef,
          textBoxXPlacement: 'end'
        }
      ]
    : []),
  {
    key: 'manage-sections',
    title: 'Manage Course Sections',
    description: 'Use this area to view or edit course sections for your survey project.',
    ref: coursesRef,
    textBoxYPlacement: 'top'
  },
  {
    key: 'section-details',
    title: 'Course Section Details',
    description: 'Adding sections allows you to send surveys to enrolled students. Once you add sections, you can also remove them as needed.',
    ref: coursesRef,
    textBoxYPlacement: 'top',
    textBoxXPlacement: 'end'
  },
  {
    key: 'complete',
    title: 'Tour Complete!',
    description: 'You have finished the guided tour. You are now ready to set up your survey project.',
    disableHighlight: true
  }
]

enum GuidedTourStepKeys {
  WELCOME_STEP = 0,
  PROJECT_INFO_STEP = 1,
  SYNC_DATES_STEP = 2,
  EMAIL_SETTINGS_STEP = 3,
  EMAIL_SCHEDULING_STEP = 4,
  MANAGE_SECTIONS_STEP = 5,
  SECTION_DETAILS_STEP = 6,
  FINAL_STEP = 7
}

export {
  GuidedTourSteps,
  GuidedTourStepKeys
}
